<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
  </cTable>
</template>

<script>
import {
  getCurrencyRate,
  add,
  getDetails,
  update,
  del
} from "@/api/finance/rate_log";
import { getCurrency } from "@/api/finance/currency";
import cTable from "@/base/common/index";
export default {
  inject: ["$page"],
  props: {
    row: {
      type: Object
    }
  },
  components: {
    cTable
  },
  data() {
    return {
      currencyList: [],
      methods: {
        list: p => {
          p.currency = this.row.code;
          return getCurrencyRate(p);
        },
        getDetails,
        del,
        add,
        update,
        getCurrency
      },
      config: {
        slot: "div",
        tabHeight: -30
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              row.currency = this.$page.$main.row.code;
              this.$page.handleRequestMethods(this.type, row).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 130
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              startDay: [
                {
                  required: true,
                  type: "date",
                  message: "startDay cannot be empty",
                  trigger: "change"
                }
              ],
              endDay: [
                {
                  type: "date",
                  required: true,
                  message: "endDay cannot be empty",
                  trigger: "change"
                }
              ],
              toCurrency: [
                {
                  required: true,
                  message: "toCurrency cannot be empty",
                  trigger: "change"
                }
              ],
              rate: [
                {
                  required: true,
                  type: "number",
                  message: "rate cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [
            { startDay: 24 },
            { endDay: 24 },
            { toCurrency: 24 },
            { rate: 24 },
            { remarks: 24 }
          ],
          fields: [
            {
              name: () => this.$t("start") + this.$t("date"),
              key: "startDay",
              component: "DatePicker",
              placeholder() {
                return this.$t("select") + this.$t("start") + this.$t("date");
              },
              bind: {
                type: "date",
                style: {
                  width: "100%"
                }
              },
              disabledDate: true,
              methods: {
                format({ value }) {
                  return value && this.format.zoneDate(value);
                }
              }
            },
            {
              name: () => this.$t("end") + this.$t("date"),
              key: "endDay",
              component: "DatePicker",
              placeholder() {
                return this.$t("select") + this.$t("end") + this.$t("date");
              },
              disabledDate: true,
              bind: {
                type: "date",
                options: {
                  disabledDate() {
                    return false;
                  }
                },
                style: {
                  width: "100%"
                }
              },
              methods: {
                format({ value }) {
                  return value && this.format.zoneDate(value);
                }
              }
            },
            {
              name: () => this.$t("toCurrency"),
              key: "toCurrency",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("toCurrency");
              },
              options: [],
              config: { label: "code", value: "code" },
              methods: {
                list: ({ field }) => {
                  field.options = this.currencyList;
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("rate"),
              key: "rate",
              component: "InputNumber",
              placeholder() {
                return this.$t("enter") + this.$t("rate");
              },
              bind: {
                style: {
                  width: "100%"
                },
                step: 0.0001,
                min: 0
              },
              default: 0
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              },
              bind: {
                type: "textarea",
                rows: 5
              }
            }
          ]
        },
        rate: {
          methods: {
            ok({ row, close }) {
              let data = this.$refs["form"].handleFilterData();
              data.id = row.id;
              this.$page.handleRequestMethods(this.type, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 130
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              type: [
                {
                  required: true,
                  message: "Currency_name cannot be empty",
                  trigger: "blur"
                }
              ],
              rate: [
                {
                  required: true,
                  message: "cannot be empty",
                  type: "number",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ type: 24 }, { rate: 24 }],
          fields: [
            {
              name: () => this.$t("type"),
              key: "type",
              component: "Select",
              placeholder() {
                return this.$t("enter") + this.$t("type");
              },
              options: [
                {
                  label: "RMB",
                  value: "RMB"
                },
                {
                  label: "USD",
                  value: "USD"
                }
              ]
            },
            {
              name: () => this.$t("rate"),
              key: "rate",
              component: "InputNumber",
              placeholder() {
                return this.$t("enter") + this.$t("rate");
              },
              bind: {
                step: 0.0001,
                min: 0,
                style: {
                  width: "100%"
                }
              }
            }
          ]
        }
      },
      header: {
        searchs: [
          {
            key: "toCurrency",
            placeholder() {
              return this.$t("select") + this.$t("toCurrency");
            },
            component: "Select",
            options: [],
            config: {
              label: "code",
              value: "code"
            }
          },
          {
            key: "startDay",
            component: "DatePicker",
            disabledDate: true,
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            bind: {
              type: "date",
              // options: {
              //   disabledDate(time) {
              //     return time.getTime() > Date.now();
              //   }
              // },
              style: {
                width: "140px"
              }
            },
            methods: {
              format({ value }) {
                return value && this.format.zoneDate(value);
              }
            }
          },
          {
            key: "endDay",
            component: "DatePicker",
            disabledDate: true,
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            bind: {
              type: "date",
              // options: {
              //   disabledDate(time) {
              //     return time.getTime() > Date.now();
              //   }
              // },
              style: {
                width: "140px"
              }
            },
            methods: {
              format({ value }) {
                return value && this.format.zoneDate(value);
              }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: 405
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, () => {
                this.getModal("add").setTitle(this.$t("add"));
                this.getModal("add").type = "add";
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        {
          name: () => this.$t("start") + this.$t("date"),
          key: "startDay",
          align: "center",
          minWidth: 100,
          tooltip: true
        },
        {
          name: () => this.$t("end") + this.$t("date"),
          key: "endDay",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("toCurrency"),
          key: "toCurrency",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("rate"),
          key: "rate",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("operate"),
          align: "center",
          key: "operator_name",
          minWidth: 160
        },
        {
          type: "btns",
          width: 120,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              id: 406
            },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
              id: 407
            }
          ],
          methods: {
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then(res => {
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").type = "update";
                this.getModal("add").open(res.payload);
              });
            },
            rate({ row }) {
              this.handleRequestMethods("getDetails", row.id).then(res => {
                this.getModal("rate").setTitle(this.$t("rate"));
                this.getModal("rate").type = "ratePut";
                this.getModal("rate").open(res.payload);
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  },
  mounted() {
    this.$refs["table"].$main = this;
    this.header.searchs.forEach(async item => {
      if (item.key === "toCurrency") {
        item.options = (
          await this.$page.handleRequestMethods("list")
        ).payload.rows.filter(item => item.code != this.row.code);
        this.currencyList = item.options;
      }
    });
  }
};
</script>
